/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line no-use-before-define
import {
  AppConstantsProvider,
  InputContainer,
  JobType,
  SET_LOCAL_DEV,
  UserProvider,
  ProcessingProvider,
} from '@klangio/react-shared-elements';
import { ThemeProvider } from '@mui/system';
import React from 'react';

import { CssBaseline } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  app: {
    textAlign: 'center',
    margin: '.5em 0',
  },
}));

interface InputContainerWidgetProps {
  baseUrl: string;
  theme: any;
  jobType: JobType;
}
SET_LOCAL_DEV(false);

export const InputContainerWidget = ({ theme, jobType, baseUrl }: InputContainerWidgetProps) => {
  const { classes } = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppConstantsProvider jobType={jobType}>
        <UserProvider>
          <ProcessingProvider>
            <div className={classes.app}>
              <InputContainer baseUrl={baseUrl} wordpress />
            </div>
          </ProcessingProvider>
        </UserProvider>
      </AppConstantsProvider>
    </ThemeProvider>
  );
};
